/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

// renew room types scroll ----
export const Home = {};

// aos ---
AOS.init();

$(() => {
  const scrollTargets = document.querySelectorAll('.j-scroll-target');
  const imgs = document.querySelector('.c-imgs');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const target = entry.target.dataset.class;

      if (entry.isIntersecting) {
        imgs.className = `d-flex c-imgs ${target}`;
      }
    });
  }, {
    root: null,
    rootMargin: '-30px 0px 0px 0px',
    threshold: 1
  });

  scrollTargets.forEach((e) => {
    observer.observe(e);
  });

  $('.j-banner-fade-out').delay('2000').fadeOut('slow');

  let swiper = new Swiper('.j-article-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    grabCursor: true,
    loop: true,
    breakpoints: {
      991: {
        slidesPerView: 1.7,
      },
      768: {
        slidesPerView: 1.2,
      },
    }
  });

  // 橫線動畫 ---
  const separators = document.querySelectorAll('.separator-line');
  const scrollPositions = [3500, 4000, 4500];

  window.addEventListener('scroll', () => {
    const scrollPosition = window.scrollY;

    separators.forEach((separator, index) => {
      if (scrollPosition > scrollPositions[index]) {
        separator.classList.add('animate');
      }
    });
  });

// 橫線動畫 ---
  const straights = document.querySelectorAll('.straight-line');
  const straightPositions = [3500, 4000, 4500];

  window.addEventListener('scroll', () => {
    const straightPosition = window.scrollY;

    straights.forEach((straight, index) => {
      if (straightPosition > straightPositions[index]) {
        straight.classList.add('animate');
      }
    });
  });
});


